export const PLATFORMS_PAGE_SLUG = 'platforms';
